/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const OrgCountryEnum = {
    Xk: 'XK',
    De: 'DE'
} as const;
export type OrgCountryEnum = typeof OrgCountryEnum[keyof typeof OrgCountryEnum];

